import { Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { getCompanyClient } from 'src/legacy/redux/slices/client';
import { getCompanyUsers } from 'src/legacy/redux/slices/user';
import { useDispatch, useSelector } from 'src/legacy/redux/store';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';

import { BasicInfoCard } from './BasicInfoCard';
import { Breadcrumbs } from './Breadcrumbs';
import { ClientDetailsNavigatorContextProvider } from './ClientDetailsNavigatorContext';
import { Tabs } from './Tabs';

export const ClientDetailsNavigator = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { themeStretch } = useSettingsContext();

  const { activeCompany } = useActiveCompany();
  const { companyUsers } = useSelector((state) => state.user);

  useEffect(() => {
    if (activeCompany && !companyUsers) {
      dispatch(getCompanyUsers(activeCompany.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyUsers]);

  useEffect(() => {
    if (id) {
      dispatch(getCompanyClient(Number(id)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <ClientDetailsNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <BasicInfoCard />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </ClientDetailsNavigatorContextProvider>
  );
};
